import { useQuery } from "@tanstack/react-query";
import {
  fetchMetaAdsCampaignDetail,
  isMetaAdsApiConfigured,
} from "./useMetaAdsApi";

/**
 * Loads a single Meta campaign (+ first ad set / creative) for the edit form.
 */
export function useMetaAdsCampaignForEdit(campaignId, options = {}) {
  const { enabled = true } = options;
  const id = String(campaignId || "").trim();
  return useQuery({
    queryKey: ["meta-ads-campaign-detail", id],
    queryFn: () => fetchMetaAdsCampaignDetail(id),
    enabled: Boolean(enabled && isMetaAdsApiConfigured() && id),
    staleTime: 30_000,
  });
}
